import {html, LitElement} from '@isceco/widget-library2/external/lit'
import CollapsibleCss from './CollapsibleCss.js'
import '@isceco/widget-library2/basic-elements/Popup/Popup.js'
import {getFomanticStylesheet} from '@isceco/widget-library2/assets/fomantic-icons-styles'

export default class Collapsible extends LitElement {
  static get styles() {
    return [CollapsibleCss]
  }

  static get properties() {
    return {
      summary: {type: String},
      helpText: {attribute: 'help-text', type: String},
      open: {type: Boolean},
      preview: { type: Boolean }
    }
  }

  connectedCallback() {
    super.connectedCallback()

    getFomanticStylesheet()
      .then(stylesheet => {
        this.shadowRoot.adoptedStyleSheets = [...this.shadowRoot.adoptedStyleSheets, stylesheet]
      })
      .catch(error => {
        throw error
      })
  }

  render() {
    return html`
      <details ?open="${this.open}" @toggle="${this._onToggle}">
        <summary class="${this.preview ? 'preview-disabled' : ''}">
          <i class="icon angle right ${this.preview ? 'disabled' : ''}"></i>
          ${this.summary}
          ${this.renderHelpText()}
        </summary>
        <div class="content">
          <slot></slot>
        </div>
      </details>
    `
  }

  renderHelpText = () => {
    if (this.helpText) {
      return html`
        <isceco-popup>
          <i slot="wrapper" class="icon info circle"></i>
          <div slot="content">
            <span style="font-size: 0.9rem">${this.helpText}</span>
          </div>
        </isceco-popup>
      `
    } else {
      return html``
    }
  }

  openCard() {
    this.open = true
    this.requestUpdate()
  }

  closeCard() {
    this.open = false
    this.requestUpdate()
  }

  toggleCard() {
    const details = this.shadowRoot?.querySelector('details')
    if (details) {
      details.open = !details.open
    }
    this.open = !!details?.open
    this.requestUpdate()
  }


  _onToggle = e => {
    if (this.preview) {
      e.currentTarget.open = this.open;
      return;
    }
    this.open = e.currentTarget.open;
  }


}

customElements.define('eform-collapsible', Collapsible)
